interface Testimonial {
  quote: string;
  name: string;
  role: string;
  industry: string;
}

const items: Testimonial[] = [
  {
    quote:
      'We replaced three tools (Tally + Marg + a custom POS) with BillBook. Day-end closing went from 2 hours to 15 minutes.',
    name: 'Rahul M.',
    role: 'Owner',
    industry: 'Sagar Ratna · Restaurant chain',
  },
  {
    quote:
      'e-Invoice and e-Way Bill generation is genuinely one click. GSTR-1 matches the books on the first try every quarter.',
    name: 'Priya S.',
    role: 'Finance Lead',
    industry: 'Studio 11 · Wholesale distributor',
  },
  {
    quote:
      'Multi-branch inventory was the killer feature for us. Stock transfers, reorder rules and a live dashboard across 7 stores.',
    name: 'Arjun K.',
    role: 'CFO',
    industry: 'Northwind Retail · Apparel chain',
  },
];

export default function Testimonials() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">What customers say</h2>
      <p className="mt-2 text-sm text-[var(--color-text-secondary)] sm:text-base">
        Real teams, real numbers — from restaurants and distributors to multi-branch retail.
      </p>

      <div className="mt-8 grid gap-4 lg:grid-cols-3">
        {items.map((t) => (
          <figure
            key={t.name}
            className="rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-card)] p-5"
          >
            <div className="text-[var(--color-primary)]">&ldquo;</div>
            <blockquote className="mt-1 text-sm leading-relaxed">{t.quote}</blockquote>
            <figcaption className="mt-4 text-xs text-[var(--color-text-secondary)]">
              <div className="font-medium text-[var(--color-text-primary)]">{t.name}</div>
              <div>
                {t.role} · {t.industry}
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
